<div class="p-4">
  <h6 *ngIf="!isProxyVote" class="m-3">Choose from the following and submit your vote</h6>

  <div *ngIf="isProxyVote">
    <h5 class="mb-0" id="h5-srs-proxy-vote">Place Vote</h5>
    <p>
      <span class="body-large-regular text-subtle">Committee Members: </span>
      <span class="body-large-bold">{{ committeeMembersDescription }}</span>
    </p>
    <p *ngIf="isSingleProxyVote && votes && votes[0].submitted">
      <span class="body-large-regular text-subtle"> Vote placed: </span>
      <span class="body-large-bold">{{
        votes[0].submitted | date : "dd/MM/yyyy"
      }}</span>
    </p>
  </div>

  <button id="modal-close-icon" class="absolute right-4 top-4" (click)="close()">
    <span class="text-lg material-symbols-rounded text-grey-800">close</span>
  </button>
  <mat-divider class="m-3 border-gray-300"></mat-divider>

  <form [formGroup]="voteOptionForm">
    <div
      class="flex items-stretch justify-between w-full gap-2 p-4 text-gray-700 children:w-1/3 children:flex-1 children:children:h-full body-default-regular">

      <div class="p-4 border border-gray-400 rounded-md"
        [ngClass]="{'border-blue-400 bg-blue-50 text-black' : inFavourOfSelect?.value}">
        <div class="flex flex-col ">

          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2">{{inFavourOf.text}}</div> <div class="material-symbols-rounded" [ngStyle]="{'color': inFavourOf.color}">{{inFavourOf.icon}}</div>
            </div>
            <div >
                <label for="inFavourOfBtn" class="flex items-center cursor-pointer">
                  <span class="mr-2">Select</span>
                  <input
                    type="checkbox"
                    id="inFavourOfBtn"
                    name="inFavourOfSelectCtrl"
                    (click)="selectInFavourOf()"
                    formControlName="inFavourOfSelectCtrl"
                    class="mr-1"
                  />
                </label>
            </div>
          </div>


          <div class="mt-2" [ngClass]="{'pointer-events-none': !inFavourOfSelect?.value}">
            <p>{{noteTitle}}</p>
            <app-text-area id="inFavourOf-note" formControlName="inFavourOfNoteCtrl" [displayCharactersCount]="false" placeholder={{noteTitle}}></app-text-area>
          </div>

        </div>
      </div>

      <div class="p-4 border border-gray-400 rounded-md"
            [ngClass]="{'border-blue-400 bg-blue-50 text-black' : againstSelect?.value}">
        <div class="flex flex-col ">
          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2">{{against.text}}</div> <div class="material-symbols-rounded" [ngStyle]="{'color': against.color}">{{against.icon}}</div>
            </div>
            <div >
                <label for="againstBtn" class="flex items-center cursor-pointer">
                  <span class="mr-2">Select</span>
                  <input
                    type="checkbox"
                    id="againstBtn"
                    name="againstSelectCtrl"
                    (click)="selectAgainst()"
                    formControlName="againstSelectCtrl"
                    class="mr-1"
                  />
                </label>
            </div>
          </div>

          <div class="mt-2"  [ngClass]="{'pointer-events-none': !againstSelect?.value}">
            <p>{{noteTitle}}<span class="ml-2 text-red-500">*</span></p>
            <app-text-area id="against-note" formControlName="againstNoteCtrl" [displayCharactersCount]="false" placeholder={{noteTitle}}></app-text-area>
          </div>

        </div>
      </div>

      <div class="p-4 border border-gray-400 rounded-md"
        [ngClass]="{'border-blue-400 bg-blue-50 text-black' : abstainSelect?.value}">
        <div class="flex flex-col ">
          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2">{{abstain.text}}</div> <div class="material-symbols-rounded" [ngStyle]="{'color': abstain.color}">{{abstain.icon}}</div>
            </div>
            <div >
              <label for="abstainBtn" class="flex items-center cursor-pointer">
                <span class="mr-2">Select</span>
                <input
                  type="checkbox"
                  id="abstainBtn"
                  name="abstainSelectCtrl"
                  (click)="selectAbstain()"
                  formControlName="abstainSelectCtrl"
                  class="mr-1"
                />
              </label>
            </div>
          </div>

          <div class="mt-2" [ngClass]="{'pointer-events-none': !abstainSelect?.value}">
            <p >{{noteTitle}}</p>
            <app-text-area id="abstain-note" formControlName="abstainNoteCtrl" [displayCharactersCount]="false" placeholder={{noteTitle}}></app-text-area>
          </div>
        </div>
      </div>



    </div>

    <div *ngIf="isProxyVote" id="add-authorisation-doc" class="flex flex-col flex-grow m-4">
      <files-upload
        title="Attach an authorization document"
        accept=".pdf,.zip,.doc,.docx,.png,.rtf,.tif,.txt,.msg"
        formControlName="authorisationDocumentCtrl">
      </files-upload>
    </div>

  </form>

  <div class="flex justify-end gap-6 mt-5 mb-5 mr-10">
    <button class="px-8 py-3 border border-black btn btn-neutral" id="vote-Cancel-Button" (click)="close()"
      type="button">Cancel</button>
    <button class="px-8 py-3 btn btn-primary" id="place-vote-Button" [disabled]="!isFormValid || isSubmitting" (click)="onSubmitClick()">Submit</button>
  </div>
</div>
